import './IllustrationBar.css';

import BombJackExtraSugarEdition from './Assets/BombJackExtraSugarEdition.jpg';
import Accueil from './Assets/Accueil.jpg';
import Sommaire from './Assets/Sommaire.jpg';
import Nouveautés from './Assets/Maj.jpg'

import React, { useContext } from 'react';
import { SharedVariableContext } from '../../App';


// Objet de mappage des noms d'images aux modules importés
const imageMap = {
                    BombJackExtraSugarEdition: BombJackExtraSugarEdition,
                    Accueil : Accueil,
                    Sommaire : Sommaire,
                    Nouveautés: Nouveautés,
                    // Ajoutez d'autres images ici si nécessaire, par exemple :
                    // BombJackExtraSugarEdition0: BombJackExtraSugarEdition0,
                };

export default function IllustrationBar()
{

    const { illustration } = useContext(SharedVariableContext);

    // Récupérer l'image correspondante ou une image par défaut si non trouvée
    const imageSrc = imageMap[illustration] || null;

    return(
        <div id='IllustrationBar'>
            {imageSrc ? (<img className = 'illustration' src={imageSrc} alt={illustration} />) : (<p>Aucune image trouvée pour : {illustration}</p>)}
        </div>

    )
}